import { useState } from "react";
import { BookOpen, ChevronDown } from "lucide-react";

export const PARCEL_TYPE_COLORS = { Agricultural: "#10B981", Irrigated: "#34D399", Residential: "#F59E0B", Commercial: "#C85A32", Forest: "#047857", Barren: "#94A3B8" };

export function MapLegend({ layers, showParcels }) {
  const [open, setOpen] = useState(true);
  const visible = [...layers].reverse();
  return (
    <div data-testid="map-legend" className="absolute z-[1000] bottom-6 right-3 glass rounded-2xl shadow-2xl text-xs w-56 overflow-hidden">
      <button type="button" data-testid="map-legend-toggle" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-4 py-2.5 font-mono uppercase tracking-[0.2em] text-[10px] font-semibold text-emerald-800 dark:text-emerald-300">
        <span className="flex items-center gap-2"><BookOpen size={12} /> Legend</span><ChevronDown size={12} className={`transition-transform ${open ? "" : "-rotate-90"}`} />
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-3 max-h-72 overflow-auto">
          {visible.length > 0 && (
            <ul className="space-y-1.5">
              {visible.map((l) => (
                <li key={l.id} data-testid={`legend-layer-${l.id}`} className="flex items-center gap-2">
                  {l.kind === "raster" ? (
                    <span className="w-4 h-3 rounded-sm shrink-0" style={{ background: l.bands >= 3 ? "linear-gradient(90deg,#64748B,#F8FAFC)" : "linear-gradient(90deg,#0F5132,#10B981,#EAB308,#C85A32,#fff)", opacity: l.opacity }} />
                  ) : (
                    <span className="w-4 h-3 rounded-sm shrink-0 border" style={{ background: l.color, opacity: Math.max(l.opacity, 0.35), borderColor: l.color }} />
                  )}
                  <span className="truncate flex-1">{l.name}{l.filter?.value ? <span className="text-muted-foreground"> · {l.filter.value}</span> : null}</span>
                </li>
              ))}
            </ul>
          )}
          {showParcels && (
            <div>
              <p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground mb-1.5">Parcel land type</p>
              <ul className="grid grid-cols-2 gap-x-3 gap-y-1">
                {Object.entries(PARCEL_TYPE_COLORS).map(([k, c]) => <li key={k} className="flex items-center gap-2"><span className="w-3 h-3 rounded-sm" style={{ background: c, opacity: 0.7 }} />{k}</li>)}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
